import React from 'react';
import TimesheetExportService from '../../Services/timesheetExportService.js';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { dateTimeHelper } from '../../Helpers/datetimeHelper.js';
import ListSelector from './listSelector.js';
import ClientService from '../../Services/clientService.js';
import LeadService from '../../Services/leadService.js';
import ProjectService from '../../Services/projectService.js';
import OpportunityService from '../../Services/opportunityService.js';
import main from '../main.module.css';
import TimeSheetEntryService from '../../Services/timeSheetEntryService.js';
import ListView from './ListView.js';
import FaIcon from '../../Elements/FaIcon.js';
import UserGuideTitle from '../../Elements/UserGuideTitle';
import ErrorMessage from '../../Elements/ErrorMessage.js';
import TimesheetHelper from '../../Helpers/ModelHelpers/TimesheetHelper.js';
import NewProjectService from '../../Services/NewProjectService.js';
import CustomDateInput from '../../Elements/InputComponents/BaseInputs/CustomDateInput';

export default class exportComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      startdate: dateTimeHelper.addDaysToDate(new Date(), -7),
      enddate: new Date(),
      leadId: -1,
      leadName: '',
      clientId: -1,
      clientName: '',
      opportunityId: -1,
      opportunityName: '',
      cfId: -1,
      cfName: '',
      projectId: -1,
      projectName: '',
      timeSheetEntryList: [],
      dateRangeError: '',
      notOnlyLeadSelectedError: '',
      listing: false,
      // Collapse the entity-filter section by default on narrow viewports, where the
      // stacked dropdowns would otherwise fill the whole screen. Open on desktop.
      filtersOpen: typeof window !== 'undefined' ? window.innerWidth > 720 : true,
      openLeadSelector: false,
      openClientSelector: false,
      openProjectSelector: false,
      openTpProjectSelector: false,
      openOpportunitySelector: false,
    };
  }

  componentDidMount() {
    // Auto-list the default (unfiltered, last-7-days) range on first load so the
    // page opens populated instead of blank until the user clicks "List".
    this.handleFilterClicked();
  }

  render() {
    const rows = this.state.timeSheetEntryList;
    const rowCount = rows.length;
    const totalHours = rows.reduce((sum, e) => sum + Number(e.spentHours || 0), 0).toFixed(2);
    const activeCount = [
      this.state.leadId,
      this.state.opportunityId,
      this.state.clientId,
      this.state.cfId,
      this.state.projectId,
    ].filter((id) => id && id !== -1).length;
    const rangeLabel = `${this.formatDot(this.state.startdate)} – ${this.formatDot(this.state.enddate)}`;

    const LeadSelectorComponent = this.state.openLeadSelector ? (
      <div className={main.selectResourcePopup}>
        <div className={main.selectResourcePopup_inner}>
          <ListSelector
            resource='lead'
            loadFunction={LeadService.GetLeadList}
            selectedResourceChange={this.selectedResourceChangeCallback}
            closeSelectorPopup={this.closeSelectorPopup.bind(this)}
            selectedId={this.state.leadId}
            selectedLabel={this.state.leadName}
          />
        </div>
      </div>
    ) : (
      ''
    );

    const ClientSelectorComponent = this.state.openClientSelector ? (
      <div className={main.selectResourcePopup}>
        <div className={main.selectResourcePopup_inner}>
          <ListSelector
            resource='client'
            loadFunction={ClientService.GetClientList}
            selectedResourceChange={this.selectedResourceChangeCallback}
            closeSelectorPopup={this.closeSelectorPopup.bind(this)}
            selectedId={this.state.clientId}
            selectedLabel={this.state.clientName}
          />
        </div>
      </div>
    ) : (
      ''
    );

    const ProjectSelectorComponent = this.state.openProjectSelector ? (
      <div className={main.selectResourcePopup}>
        <div className={main.selectResourcePopup_inner}>
          <ListSelector
            resource='project'
            loadFunction={ProjectService.GetProjectList}
            selectedResourceChange={this.selectedResourceChangeCallback}
            closeSelectorPopup={this.closeSelectorPopup.bind(this)}
            selectedId={this.state.cfId}
            selectedLabel={this.state.cfName}
            clientIdFilter={this.state.clientId}
          />
        </div>
      </div>
    ) : (
      ''
    );

    const TpProjectSelectorComponent = this.state.openTpProjectSelector ? (
      <div className={main.selectResourcePopup}>
        <div className={main.selectResourcePopup_inner}>
          <ListSelector
            resource='tpproject'
            loadFunction={NewProjectService.GetProjectList}
            selectedResourceChange={this.selectedResourceChangeCallback}
            closeSelectorPopup={this.closeSelectorPopup.bind(this)}
            selectedId={this.state.projectId}
            selectedLabel={this.state.projectName}
            clientIdFilter={this.state.clientId}
          />
        </div>
      </div>
    ) : (
      ''
    );

    const OpportunitySelectorComponent = this.state.openOpportunitySelector ? (
      <div className={main.selectResourcePopup}>
        <div className={main.selectResourcePopup_inner}>
          <ListSelector
            resource='opportunity'
            loadFunction={OpportunityService.GetOpportunityList}
            selectedResourceChange={this.selectedResourceChangeCallback}
            closeSelectorPopup={this.closeSelectorPopup.bind(this)}
            selectedId={this.state.opportunityId}
            selectedLabel={this.state.opportunityName}
            clientIdFilter={this.state.clientId}
            projectIdFilter={this.state.cfId}
            tpProjectIdFilter={this.state.projectId}
          />
        </div>
      </div>
    ) : (
      ''
    );

    return (
      <div className='contentwrapper bravo-ds ex-page'>
        {/* header */}
        <div className='page-head'>
          <div className='page-title'>
            <span className='eq-mark'>
              <span></span>
              <span></span>
            </span>
            <div className='page-title-text'>
              <div className='eyebrow'>Activity</div>
              <h1>
                <UserGuideTitle title='Export' />
              </h1>
            </div>
          </div>
          <div className='ex-actions'>
            <div className='count-pill ex-count'>
              <b>{rowCount}</b>
              <span>entries</span>
            </div>
            <div className='divider'></div>
            <button
              type='button'
              className='btn primary'
              onClick={this.handleExportClicked.bind(this)}
              disabled={rowCount === 0}
            >
              <FaIcon iconName='fa-solid fa-paper-plane' /> Export XLSX
            </button>
          </div>
        </div>

        {/* scroll body */}
        <div className='ex-body'>
          {/* filter card */}
          <section className='ex-card'>
            <div className='ex-toprow'>
              <div className='ex-field'>
                <label className='ex-lbl'>Start date</label>
                <span className='ds-datefield'>
                  <DatePicker
                    selected={this.state.startdate}
                    selectsStart
                    startDate={this.state.startdate}
                    endDate={this.state.enddate}
                    onChange={this.handleSelectedStartDateChange.bind(this)}
                    calendarClassName='ds-datecal'
                    customInput={<CustomDateInput />}
                  />
                </span>
              </div>
              <div className='ex-field'>
                <label className='ex-lbl'>End date</label>
                <span className='ds-datefield'>
                  <DatePicker
                    selected={this.state.enddate}
                    selectsEnd
                    startDate={this.state.startdate}
                    endDate={this.state.enddate}
                    onChange={this.handleSelectedEndDateChange.bind(this)}
                    calendarClassName='ds-datecal'
                    customInput={<CustomDateInput />}
                  />
                </span>
              </div>
              <div className='ex-sp'></div>
              <button
                type='button'
                className={'btn navy ex-list' + (this.state.listing ? ' loading' : '')}
                onClick={this.handleListClicked.bind(this)}
              >
                <FaIcon iconName={this.state.listing ? 'fa-solid fa-arrows-rotate' : 'fa-solid fa-list'} /> List
                timesheet entries
              </button>
              {this.state.dateRangeError ? <div className='ex-err'>{this.state.dateRangeError}</div> : null}
            </div>

            <button
              type='button'
              className='ex-filtertoggle'
              aria-expanded={this.state.filtersOpen}
              onClick={() => this.setState((s) => ({ filtersOpen: !s.filtersOpen }))}
            >
              <span className='ex-ft-label'>
                <FaIcon iconName='fa-solid fa-filter' /> Filters
                {activeCount ? <span className='ex-ft-badge'>{activeCount}</span> : null}
              </span>
              <FaIcon iconName={this.state.filtersOpen ? 'fa-solid fa-chevron-up' : 'fa-solid fa-chevron-down'} />
            </button>

            {this.state.filtersOpen ? (
              <>
                <div className='ex-filters'>
                  {this.renderFilterField('Lead', this.state.leadName, this.state.leadId, 'openLeadSelector', 'lead')}
                  {this.renderFilterField(
                    'Opportunity',
                    this.state.opportunityName,
                    this.state.opportunityId,
                    'openOpportunitySelector',
                    'opportunity'
                  )}
                  {this.renderFilterField(
                    'Client',
                    this.state.clientName,
                    this.state.clientId,
                    'openClientSelector',
                    'client'
                  )}
                  {this.renderFilterField(
                    'Project',
                    this.state.cfName,
                    this.state.cfId,
                    'openProjectSelector',
                    'project'
                  )}
                  {this.renderFilterField(
                    'Third-Party Project',
                    this.state.projectName,
                    this.state.projectId,
                    'openTpProjectSelector',
                    'tpproject'
                  )}
                </div>

                <div className='ex-filterfoot'>
                  <span className='ex-hint'>
                    {activeCount ? (
                      <>
                        <b>{activeCount}</b> filter{activeCount === 1 ? '' : 's'} active
                      </>
                    ) : (
                      'No filters — all entries in range'
                    )}
                  </span>
                  <button
                    type='button'
                    className='btn danger-ghost'
                    onClick={this.handleResetFilters.bind(this)}
                    disabled={activeCount === 0}
                  >
                    <FaIcon iconName='fa-solid fa-eraser' /> Reset filters
                  </button>
                </div>
              </>
            ) : null}
          </section>

          {/* results */}
          <section className='ex-tablecard'>
            <div className='ex-thead'>
              <span className='th-title'>Timesheet entries</span>
              <span className='ex-range'>{rangeLabel}</span>
              <span className='ex-sp'></span>
              <span className='ex-tsum'>
                <b>{totalHours}</b> hours · <b>{rowCount}</b> rows
              </span>
            </div>
            <ListView
              timeSheetEntryListChange={(timeSheetEntryList) => this.setState({ timeSheetEntryList })}
              timeSheetEntryList={this.state.timeSheetEntryList}
              selectedDate={this.state.startdate}
              selectedEndDate={this.state.enddate}
            />
          </section>
        </div>

        {LeadSelectorComponent}
        {ClientSelectorComponent}
        {ProjectSelectorComponent}
        {TpProjectSelectorComponent}
        {OpportunitySelectorComponent}
      </div>
    );
  }

  renderFilterField(label, name, id, openStateKey, resourceType) {
    const hasSelection = !!id && id !== -1;
    return (
      <div className='ex-field'>
        <label className='ex-lbl'>{label}</label>
        <div className='ex-select-wrap'>
          <button
            type='button'
            className={'ex-select' + (hasSelection ? ' has' : '')}
            onClick={() => this.setState({ [openStateKey]: true })}
          >
            <span className='v'>{this.formatLabeling(name) || 'Please select'}</span>
            <span className='cv'>
              <FaIcon iconName='fa-solid fa-chevron-down' />
            </span>
          </button>
          {hasSelection ? (
            <button
              type='button'
              className='ex-clear'
              title='Clear'
              onClick={() => this.clearLabelling(resourceType)}
            >
              <FaIcon iconName='fa-solid fa-xmark' />
            </button>
          ) : null}
        </div>
      </div>
    );
  }

  formatDot(date) {
    return `${dateTimeHelper.toYYYYsMMsDD(date, '.')}.`;
  }

  handleSelectedStartDateChange(date) {
    this.setState({ startdate: date }, this.validateDateRange);
  }

  handleSelectedEndDateChange(date) {
    this.setState({ enddate: date }, this.validateDateRange);
  }

  handleListClicked() {
    if (this.validateDateRange() || this.validateNotOnlyLeadSelectedError()) {
      return;
    }
    this.setState({ listing: true });
    Promise.resolve(this.handleFilterClicked())
      .then(() => {
        this.setState({ listing: false });
        ErrorMessage.SetNotification('Timesheet entries listed.');
      })
      .catch(() => this.setState({ listing: false }));
  }

  handleFilterClicked(leadId, clientId, opportunityId, cfId, projectId) {
    if (!(!this.validateDateRange() && !this.validateNotOnlyLeadSelectedError())) {
      return;
    }
    const startDateAsDate = new Date(dateTimeHelper.toYYYYsMMsDD(this.state.startdate));
    const endDateAsDate = new Date(dateTimeHelper.toYYYYsMMsDD(dateTimeHelper.addDaysToDate(this.state.enddate, 1)));
    return TimeSheetEntryService.GetTimeSheetEntriesSplitByDay(
      startDateAsDate,
      endDateAsDate,
      leadId ?? this.state.leadId,
      clientId ?? this.state.clientId,
      opportunityId ?? this.state.opportunityId,
      cfId ?? this.state.cfId,
      projectId ?? this.state.projectId
    )
      .then((result) => {
        this.setState({
          timeSheetEntryList: TimesheetHelper.GetSpentHoursForEntries(
            TimeSheetEntryService.ConvertDBTimesheetEntries(result, true)
          ),
        });
      })
      .catch(() => ErrorMessage.SetErrorMessage('E308'));
  }

  handleResetFilters() {
    this.setState({
      leadId: -1,
      leadName: '',
      clientId: -1,
      clientName: '',
      opportunityId: -1,
      opportunityName: '',
      cfId: -1,
      cfName: '',
      projectId: -1,
      projectName: '',
      notOnlyLeadSelectedError: '',
    });
    this.handleFilterClicked(-1, -1, -1, -1, -1);
    ErrorMessage.SetNotification('Filters cleared.');
  }

  handleExportClicked() {
    if (this.state.timeSheetEntryList.length === 0) {
      ErrorMessage.SetWarning('No entries found with this criteria.');
      return;
    }
    const startDateAsDate = new Date(dateTimeHelper.toYYYYsMMsDD(this.state.startdate));
    const endDateAsDate = new Date(dateTimeHelper.toYYYYsMMsDD(dateTimeHelper.addDaysToDate(this.state.enddate, 1)));
    TimesheetExportService.GetTimesheetReport(
      startDateAsDate,
      endDateAsDate,
      this.state.leadId,
      this.state.clientId,
      this.state.opportunityId,
      this.state.cfId,
      this.state.projectId
    );
  }

  formatLabeling(text) {
    if (text == null || text.length < 1) {
      return '';
    }
    return text;
  }

  closeSelectorPopup() {
    this.setState({
      openLeadSelector: false,
      openClientSelector: false,
      openProjectSelector: false,
      openTpProjectSelector: false,
      openOpportunitySelector: false,
    });
  }

  selectedResourceChangeCallback = (selectedResource) => {
    switch (selectedResource.resourceType) {
      case 'lead':
        this.setState({
          openLeadSelector: false,
          leadName: selectedResource.label,
          leadId: selectedResource.value,
        });
        this.validateNotOnlyLeadSelectedError();
        this.handleFilterClicked(selectedResource.value);
        break;
      case 'client':
        this.setState({
          openClientSelector: false,
          clientName: selectedResource.label,
          clientId: selectedResource.value,
        });
        if (selectedResource.value !== -1) {
          this.setState({
            cfId: -1,
            cfName: '',
            projectId: -1,
            projectName: '',
            opportunityId: -1,
            opportunityName: '',
          });
        }
        this.validateNotOnlyLeadSelectedError();
        this.handleFilterClicked(null, null, selectedResource.value, -1, -1);
        break;
      case 'opportunity':
        this.setState({
          openOpportunitySelector: false,
          opportunityName: selectedResource.label,
          opportunityId: selectedResource.value,
        });
        this.validateNotOnlyLeadSelectedError();
        this.handleFilterClicked(null, null, selectedResource.value);
        break;
      case 'project':
        this.setState({
          openProjectSelector: false,
          cfName: selectedResource.label,
          cfId: selectedResource.value,
        });
        this.validateNotOnlyLeadSelectedError();
        this.handleFilterClicked(null, null, null, selectedResource.value);
        break;
      case 'tpproject':
        this.setState({
          openTpProjectSelector: false,
          projectName: selectedResource.label,
          projectId: selectedResource.value,
        });
        this.validateNotOnlyLeadSelectedError();
        this.handleFilterClicked(null, null, null, null, selectedResource.value);
        break;
      default:
        break;
    }
  };

  validateNotOnlyLeadSelectedError() {
    let error = '';

    if (
      this.state.leadId != null &&
      this.state.leadId !== -1 &&
      ((this.state.clientId != null && this.state.clientId !== -1) ||
        (this.state.cfId != null &&
          this.state.cfId !== -1 &&
          this.state.projectId != null &&
          this.state.projectId !== -1) ||
        (this.state.opportunityId != null && this.state.opportunityId !== -1))
    ) {
      error = 'Selecting a lead with client / project / opportunity is not possible.';
      ErrorMessage.SetNotification(error);
    }

    this.setState({ notOnlyLeadSelectedError: error });

    return error;
  }

  validateDateRange() {
    let error = '';

    if (new Date(this.state.startdate) > new Date(this.state.enddate)) {
      error = 'End date must be later than start date';
      ErrorMessage.SetNotification(error);
    }

    this.setState({ dateRangeError: error });

    return error;
  }

  clearLabelling(resourceType) {
    switch (resourceType) {
      case 'client':
        this.setState({
          clientName: '',
          clientId: -1,
        });
        this.handleFilterClicked(null, -1);
        break;
      case 'lead':
        this.setState({
          leadName: '',
          leadId: -1,
        });
        this.handleFilterClicked(-1);
        break;
      case 'project':
        this.setState({
          cfName: '',
          cfId: -1,
        });
        this.handleFilterClicked(null, null, null, -1);
        break;
      case 'tpproject':
        this.setState({
          projectName: '',
          projectId: -1,
        });
        this.handleFilterClicked(null, null, null, null, -1);
        break;
      case 'opportunity':
        this.setState({
          opportunityName: '',
          opportunityId: -1,
        });
        this.handleFilterClicked(null, null, -1);
        break;
      default:
        break;
    }
  }
}
